export default {
  meta: {
    title: '行业地图-分享',
  },
};
